module.exports = __webpack_public_path__ + "img/Property 1=4x3, Property 2=AT - Austria.31f2b43c.svg";